
import { defineComponent, onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";

import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "merchant-settings-modal",
  components: {},
  props: {
    cardClasses: String,
  },
  setup() {
    const route = useRoute();
    const getMerchantId = computed(() => {
      return route.params.id;
    });

    const products = ref([]);

    onMounted(async () => {
      setTimeout(async () => {
        await getProducts();
      }, 1000);
    });

    const getProducts = async () => {
      try {
        const res = await ApiService.get(
          `merchants/accounts/${getMerchantId.value}?fields=products`
        );
        if (res.data.success) {
          products.value = JSON.parse(res.data.data[0].products);
        }
      } catch (e) {
        products.value = [];
      }
    };

    return {
      products,
    };
  },
});
